/* eslint-disable no-restricted-imports */
/* eslint-disable functional/no-loop-statement */
import { OrderItemListRows } from '@/data/Content/OrderItemList';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

export const extractElectronicsByOrderItemList = (products: OrderItemListRows) => {
	const electronics = products.reduce((acc, product) => {
		const attributes = product?.details.attributes ?? [];

		const attributeUse = findProductAttribute(attributes, 'Uso');

		const newAcc = [...acc];

		if (['Electronicos', 'Electrónicos'].includes(attributeUse?.value ?? '')) {
			newAcc.push(product);
		}

		return newAcc;
	}, [] as OrderItemListRows);

	return electronics;
};

export const searchContainsElectronic = (products: OrderItemListRows) => {
	const electronicsByOrderItemList = extractElectronicsByOrderItemList(products);
	return electronicsByOrderItemList.length > 0;
};
